// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Fira+Sans:400,500,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  background: #1c8ef9 !important;
  min-height: 100vh;
  display: flex;
  font-weight: 400;
  font-family: "Fira Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
label,
span {
  font-weight: 500;
  font-family: "Fira Sans", sans-serif;
}

body,
html,
.App,
#root,
.auth-wrapper {
  width: 100%;
  height: 100%;
}

.navbar-light {
  background-color: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
}

.auth-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
}

.auth-inner {
  width: 600px;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);
  padding: 40px 55px 45px 55px;
  border-radius: 15px;
  transition: all 0.3s;
}

.auth-wrapper .form-control:focus {
  border-color: #167bff;
  box-shadow: none;
}

.auth-wrapper h3 {
  text-align: center;
  margin: 0;
  line-height: 1;
  padding-bottom: 20px;
}

.custom-control-label {
  font-weight: 400;
}

.forgot-password,
.forgot-password a {
  text-align: right;
  font-size: 13px;
  padding-top: 10px;
  color: #7f7d7d;
  margin: 0;
}

.forgot-password a {
  color: #167bff;
}

.payuform {
  display: none;
}

.showdiv {
  display: block;
  transition: visibility 0s linear 0.33s, opacity 0.33s linear;
  transition-delay: 3s;
}


.payment-success h1 {
  color: #88B04B;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-weight: 900;
  font-size: 40px;
  margin-bottom: 10px;
}

.payment-success p {
  color: #404F5E;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  margin: 0;
}

.payment-success i {
  color: #9ABC66;
  font-size: 100px;
  line-height: 200px;
}

.card.payment-success {
  background: white;
  padding: 80px;
  border-radius: 4px;
  box-shadow: 0 2px 3px #C8D0D8;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
}



.payment-failed h1 {
  color: #f92f60;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-weight: 900;
  font-size: 40px;
  margin-bottom: 10px;
}

.payment-failed p {
  color: #404F5E;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  margin: 0;
}

.payment-failed b {
  color: #f92f60;
  font-size: 100px;
  line-height: 200px;
}

.card.payment-failed {
  background: white;
  padding: 80px;
  border-radius: 4px;
  box-shadow: 0 2px 3px #C8D0D8;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
}

.searchdata {
  position: relative;
  float: right;
  top: -1.7rem;
  margin-right: 10px;
  cursor: pointer;
}


/* start receipt css */
.logo-div {
  text-align: center;
}

.receipt-logo {
  width: 100px;
}

.payment-content {
  padding: 0px 20px;
}

.payment-card {
  padding: 30px 10px;
  max-width: 700px;
}

.print-button {
  text-align: center;
}

button.btn.btn-success.receipt-btn {
  width: 150px;
  margin: 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,4DAA4D;EAC5D,oBAAoB;AACtB;;;AAGA;EACE,cAAc;EACd,wDAAwD;EACxD,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wDAAwD;EACxD,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;;;AAIA;EACE,cAAc;EACd,wDAAwD;EACxD,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wDAAwD;EACxD,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;;AAGA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Fira+Sans:400,500,600,700,800\");\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  background: #1c8ef9 !important;\n  min-height: 100vh;\n  display: flex;\n  font-weight: 400;\n  font-family: \"Fira Sans\", sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nlabel,\nspan {\n  font-weight: 500;\n  font-family: \"Fira Sans\", sans-serif;\n}\n\nbody,\nhtml,\n.App,\n#root,\n.auth-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.navbar-light {\n  background-color: #ffffff;\n  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);\n}\n\n.auth-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  text-align: left;\n}\n\n.auth-inner {\n  width: 600px;\n  margin: auto;\n  background: #ffffff;\n  box-shadow: 0px 14px 80px rgba(34, 35, 58, 0.2);\n  padding: 40px 55px 45px 55px;\n  border-radius: 15px;\n  transition: all 0.3s;\n}\n\n.auth-wrapper .form-control:focus {\n  border-color: #167bff;\n  box-shadow: none;\n}\n\n.auth-wrapper h3 {\n  text-align: center;\n  margin: 0;\n  line-height: 1;\n  padding-bottom: 20px;\n}\n\n.custom-control-label {\n  font-weight: 400;\n}\n\n.forgot-password,\n.forgot-password a {\n  text-align: right;\n  font-size: 13px;\n  padding-top: 10px;\n  color: #7f7d7d;\n  margin: 0;\n}\n\n.forgot-password a {\n  color: #167bff;\n}\n\n.payuform {\n  display: none;\n}\n\n.showdiv {\n  display: block;\n  transition: visibility 0s linear 0.33s, opacity 0.33s linear;\n  transition-delay: 3s;\n}\n\n\n.payment-success h1 {\n  color: #88B04B;\n  font-family: \"Nunito Sans\", \"Helvetica Neue\", sans-serif;\n  font-weight: 900;\n  font-size: 40px;\n  margin-bottom: 10px;\n}\n\n.payment-success p {\n  color: #404F5E;\n  font-family: \"Nunito Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 20px;\n  margin: 0;\n}\n\n.payment-success i {\n  color: #9ABC66;\n  font-size: 100px;\n  line-height: 200px;\n}\n\n.card.payment-success {\n  background: white;\n  padding: 80px;\n  border-radius: 4px;\n  box-shadow: 0 2px 3px #C8D0D8;\n  display: inline-block;\n  margin: 0 auto;\n  text-align: center;\n}\n\n\n\n.payment-failed h1 {\n  color: #f92f60;\n  font-family: \"Nunito Sans\", \"Helvetica Neue\", sans-serif;\n  font-weight: 900;\n  font-size: 40px;\n  margin-bottom: 10px;\n}\n\n.payment-failed p {\n  color: #404F5E;\n  font-family: \"Nunito Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 20px;\n  margin: 0;\n}\n\n.payment-failed b {\n  color: #f92f60;\n  font-size: 100px;\n  line-height: 200px;\n}\n\n.card.payment-failed {\n  background: white;\n  padding: 80px;\n  border-radius: 4px;\n  box-shadow: 0 2px 3px #C8D0D8;\n  display: inline-block;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.searchdata {\n  position: relative;\n  float: right;\n  top: -1.7rem;\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n\n/* start receipt css */\n.logo-div {\n  text-align: center;\n}\n\n.receipt-logo {\n  width: 100px;\n}\n\n.payment-content {\n  padding: 0px 20px;\n}\n\n.payment-card {\n  padding: 30px 10px;\n  max-width: 700px;\n}\n\n.print-button {\n  text-align: center;\n}\n\nbutton.btn.btn-success.receipt-btn {\n  width: 150px;\n  margin: 0px 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
